import { createApp } from 'vue'
import App from './App.vue'

// import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown, faChevronLeft, faSearch, faChevronUp, faChevronRight, faXmark, faPlus, faMinus, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import store from './store'
import Logger from './helpers/logger'

library.add(faSearch);
library.add(faChevronDown);
library.add(faChevronUp);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faXmark);
library.add(faPlus);
library.add(faMinus);
library.add(faArrowRight);

createApp(App).use(store).component("font-awesome-icon", FontAwesomeIcon).mount('#shopping-cart-component')

// Subscribe to store updates
store.subscribe((mutation, state) => {
	// Store the state object as a JSON string
	localStorage.setItem('HBGCartStore', JSON.stringify(state));
            if (mutation.type === 'SET_PRODUCTS' || mutation.type === 'OPTIMISTIC_SET_PRODUCT_QUANTITY' || mutation.type === 'OPTIMISTIC_DELETE_PRODUCT' || mutation.type === 'LOAD_CART' || mutation.type === 'SET_CART' || mutation.type === 'initializeStore'){
                        window.EventBus.dispatchEvent('updated-cart', {    
                                    quantity: state.products.map(item => item.quantity).reduce((a,b) => a+b, 0)
                        });
                        Logger.log('DISPATCHED EVENT UPDATED CART');
            Logger.log(state.products.map(item => item.quantity).reduce((a,b) => a+b, 0));
            }
            
});